import { useEffect, useState } from "react";
import type { LinkApiClient, LinkServiceStatus } from "./linkApiClient";

interface LinkServiceStatusState {
  status: LinkServiceStatus | null;
  error: string | null;
}

export function useLinkServiceStatus(client: LinkApiClient): LinkServiceStatusState {
  const [state, setState] = useState<LinkServiceStatusState>({
    status: null,
    error: null,
  });

  useEffect(() => {
    const controller = new AbortController();
    void client
      .inspectService(controller.signal)
      .then((status) => {
        setState({ status, error: null });
      })
      .catch((error: unknown) => {
        if (!(error instanceof DOMException && error.name === "AbortError")) {
          setState({
            status: null,
            error: "The temporary link service could not be confirmed.",
          });
        }
      });
    return () => controller.abort();
  }, [client]);

  return state;
}
